{
    "no_product_found": "Kein Produkt ausgewählt",
    "add_product": "Hinzufügen",
    "toast__product_added_title": "Artikel hinzugefügt",
    "toast__product_added_body": "{{quantity}} {{unit}} wurde(n) zum Entwurf hinzugefügt",
    "iframe_title": "Produktkatalog"
}
